import { isValidDocumentNumber, Relation } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import {
  phoneValidation,
  requiredDialCode,
  requiredEmail,
  requiredEnum,
  requiredFutureDate,
  requiredNumber,
  requiredPastDate,
  requiredPhoneNumber,
  requiredString,
} from '@/utils/zodUtils';

export const HolderDetailsFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      firstName: requiredString(t),
      lastName: requiredString(t),
      birthDate: requiredPastDate(t).nullable(),
      birthCountry: requiredString(t),
      nationality: requiredString(t),
      documentNumber: z.string(),
      expiration: requiredFutureDate(t).nullable(),
      email: requiredEmail(t).nullable(),
      dialCode: requiredDialCode(t),
      phoneNumber: requiredPhoneNumber(t),
      grantingPowersDate: requiredPastDate(t).nullable(),
      percentage: requiredNumber(t).nullable(),
      relationshipWithOwner: requiredEnum(Relation, t).nullable(),
    })
    .strict()
    .refine((data) => !(data.phoneNumber && data.dialCode && !phoneValidation(data)), {
      message: t('INVALID_PHONE_NUMBER'),
      path: ['phoneNumber'],
    })
    .refine((data) => isValidDocumentNumber(data.documentNumber), {
      message: t('INVALID_DOCUMENT_NUMBER'),
      path: ['documentNumber'],
    });

export type HolderDetailsFormType = z.infer<ReturnType<typeof HolderDetailsFormSchema>>;
